import { render } from "./OurFeaturedSolutions.vue?vue&type=template&id=2cdc189e"
import script from "./OurFeaturedSolutions.vue?vue&type=script&lang=js"
export * from "./OurFeaturedSolutions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__